import req from 'libs/http';
const all_item = {
  id: -1,
  name: '全部'
}
export default {
  async init() {
    let cateList = [];
    let res = await req.post('/basic/data/book/category.json');
    if (res.status == 200) {
      let list = res.data || [];
      let item = {
        ...all_item
      }
      list.unshift(item);
      cateList.push({
        id: 'category',
        name: '题材分类',
        list
      });
    }
    res = await req.post('/basic/data/book/grade.json');
    if (res.status == 200) {
      let list = res.data || [];
      let item = {
        ...all_item
      }
      list.unshift(item);
      cateList.push({
        id: 'grade',
        name: '年级选择',
        list
      });
    }
    return cateList;
  }
}
